export default __webpack_public_path__ + "static/media/SPORT 100 ELS_3.3f766a92.webp";